import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import LoadingSpinner from './components/LoadingSpinner'
import EmailPopup from './components/EmailPopup'

// Lazy load pages for code splitting
const HomePage = lazy(() => import('./pages/HomePage'))
const SoulFoodStoryPage = lazy(() => import('./pages/SoulFoodStoryPage'))
const DirectoryPage = lazy(() => import('./pages/DirectoryPage'))
const RecipesPage = lazy(() => import('./pages/RecipesPage'))
const HistoryPage = lazy(() => import('./pages/HistoryPage'))
const SubmitBusinessPage = lazy(() => import('./pages/SubmitBusinessPage'))
const AdminPanel = lazy(() => import('./pages/AdminPanel'))

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-warm-cream">
        {/* Skip to main content - Accessibility */}
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        
        <Header />
        
        <main id="main-content" className="flex-grow">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/story" element={<SoulFoodStoryPage />} />
              <Route path="/directory" element={<DirectoryPage />} />
              <Route path="/recipes" element={<RecipesPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/submit" element={<SubmitBusinessPage />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </Suspense>
        </main>
        
        <Footer />
        
        {/* Email Popup for first-time visitors */}
        <EmailPopup />
      </div>
    </Router>
  )
}

export default App
